import React, { useState } from 'react';
import QuickOrderHeader from './components/QuickOrderHeader';
import QuickOrderBulkAddPopup from './components/QuickOrderBulkAddPopup';
import Spinner from 'src/common/refactoredComponents/spinner/Spinner';
import { useTranslation } from 'react-i18next';
import {
    AutocompleteStyles,
    QuickOrderContainer,
    AutoCompleteInputFieldStyle,
    LoadingTextStyles,
    SpinningLoaderContainer,
} from './QuickOrderCommon.styled';
import Backdrop from 'src/common/refactoredComponents/backdrop/Backdrop';
import SearchGrayInactive from 'src/assets/images/SearchGrayInactive.svg';
import { dynamicPluralization } from 'src/utils/util';
import { sizes } from 'src/styles/Media.styled';
import axios from 'src/api/Api';
import { useSelector, shallowEqual } from 'react-redux';
import {
    isIpad,
    isLandscape,
    updateNavBarPosition,
    logErrorToConsole,
} from 'src/utils/util';
import BomNotification from '../../../pages/scheduleSurgery/components/cart/bomNotification/index';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import SetItemModal from 'src/common/components/setItemModal';
import ListView from 'src/common/organisms/listView/index.jsx';
import CondensedMobileView from 'src/common/refactoredComponents/condensedMobileView/CondensedMobileView';
import CondensedMobileViewList from 'src/common/refactoredComponents/condensedMobileView/CondensedMobileViewList';
import { BASE_TEXT_PX } from '../../../styles/fonts/MCFontConstants';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { checkProxyActive } from 'src/utils/util';

const QuickOrderContainerCommon = ({
    isCondensedView,
    padding,
    setShowBulkAdd,
    selectedProduct,
    productsList,
    handleOnOpen,
    open,
    loading,
    productsListTemplate,
    updateSelectedProduct,
    autoCompleteInputChange,
    handlekeyPress,
    cancelSearchRequest,
    setOpen,
    isBulkUpload,
    setOrItemNumbers,
    products,
    deleteSetOrItem,
    showBulkAdd,
    bulkValues,
    setBulkValues,
    addToList,
    copyToClipBoard,
    productValidationLoading,
    isEquity,
    getPriceForItems,
    setIsCheckPrice,
    setIsCheckPriceClicked,
    isTemplate,
    isSurgery = {
        position: 'fixed',
        width: { standard: 'calc(100% - 5rem)', smallDevice: '100%' },
        padding: '10px',
        inPaddingVertical: '5px',
    },
    setsQuantityCheck,
    onSelectClose,
    onSelectOpen,
    addCounter,
    removeCounter,
    handleBundlePopup,
    handleBundleSetItemClick,
    isCartScreen,
    toggleProduct,
    setExpandedProducts,
    expandedProducts,
    setIsQuantityMoreThan50,
    moreTemplates,
    isEquityTemplate,
    isEquityPage,
    isQuickOrderEquityTemplate,
    updateProductQuantity,
    landscapeMarginTop,
    isSurgeryTemplate = false,
    mbPaddingTop,
    mbTextAreaHeight,
    isBanner,
    isConsignmentAdd,
    mobileHeight,
    smlMarginBottom,
    cartProducts
}) => {
    const [editableHeight, setEditableHeight] = useState('');
    const { t } = useTranslation();
    const [ipad, setIpad] = useState(isIpad());
    const [landscape, setLandscape] = useState(isLandscape());
    const [, setAxiosSource] = useState({});
    const [setDetails, showSetDetails] = useState(false);
    const [itemDetails, showItemDetails] = useState(false);
    const [selectedItem, setSelectedItem] = useState('');
    const [productStack, setProductStack] = useState([]);
    const [, setPopupFlag] = useState(false);
    const [dialogZindex, setDialogZindex] = useState(10000);
    const [, setPreviousItem] = useState('');
    const [quickOrderSearch,setQuickOrderSearch]=useState('');
    let timoutId;

    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
        window.addEventListener('orientationchange', updateLandscape, false);
        setIpad(isIpad());
        isIpad() && updateNavBarPosition('unset');
        return () => {
            window.removeEventListener(
                'orientationchange',
                updateLandscape,
                false
            );
            updateNavBarPosition('fixed');
        };
    }, []);

    const updateLandscape = () => {
        setEditableHeight('');
        document.activeElement.blur();
        setLandscape(!isLandscape());
        timoutId = setTimeout(() => {
            try {
                handleDynamicBulkAdd();
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 100);
    };

    const handleDynamicBulkAdd = () => {
        if (ipad && landscape) {
            setEditableHeight('230px');
        } else {
            setEditableHeight('');
        }
        clearTimeout(timoutId);
        timoutId = undefined;
    };

    const resetPosition = () => {
        setEditableHeight('');
        setTimeout(() => {
            try {
                if (isMobileView() || isIpad()) {
                    document.getElementById('popUpContent').style.position = '';
                    document.getElementById('popUpContent').style.top = '';
                }
            }
            catch (error) {
                logErrorToConsole(error);
            }
        }, 0);
    };

    const ensureProductKeys = (products) => {
        const usedKeys = new Set();

        const ensureUniqueKey = (key) => {
            if (!key || usedKeys.has(key)) {
                const newKey = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
                usedKeys.add(newKey);
                return newKey;
            }
            usedKeys.add(key);
            return key;
        };

        return products.map((product) => {
            const productKey = ensureUniqueKey(product.productKey);

            const children = Array.isArray(product.children)
                ? product.children.map((child) => ({
                      ...child,
                      productKey: ensureUniqueKey(child.productKey),
                  }))
                : product.children;

            const bundleItems = Array.isArray(product.bundleItems)
                ? product.bundleItems.map((bundleItem) => ({
                      ...bundleItem,
                      productKey: ensureUniqueKey(bundleItem.productKey),
                  }))
                : product.bundleItems;

            return {
                ...product,
                productKey,
                children,
                bundleItems,
            };
        });
    };

    const winWidth = window.innerWidth;
    const isMobileView = winWidth <= sizes.mobileDevice;

    const [bomNotification, setBomNotification] = useState(false);
    const [bomSetDetails, setBomSetDetails] = useState(false);

    const closeBomModal = () => {
        setBomNotification(false);
        setBomSetDetails({});
    };

    const handleSetItemClick = (item, isBack) => {
        const { isSet, cfn, productCFN, bom } = item;
        const newItem = {
            ...item,
            cfn: productCFN || cfn || bom,
        };
        if (isSet) {
            showSetDetails(true);
            showItemDetails(false);
            setSelectedItem(newItem);
        } else {
            showSetDetails(false);
            showItemDetails(true);
            setSelectedItem(newItem);
        }
        handleProductStack(newItem, isBack === true ? false : true);
    };

    const handleProductStack = (item, isAdd) => {
        if (isAdd) {
            setProductStack([...productStack, item]);
        } else {
            let list = productStack.slice(0, -1);
            setProductStack(list);
        }
    };

        const [showBanner, setShowBanner] = useState(false);

    const bannerInfo = useSelector(
        (state) => state.loginReducer.bannerInfo,
        shallowEqual
    );
    const isImpersonationActive = useSelector(
        (state) => state.impersonationReducer.isImpersonationActive
    );

    useEffectWithErrorLogging(() => {
        let userInfoMessages = [];
        if (bannerInfo) {
            userInfoMessages = bannerInfo.filter(
                (item) => item.messageType === 'userInfoMessage'
            );
        }
        if (userInfoMessages.length > 0) {
            setShowBanner(true);
        }
    }, []);

    const showSingleBanner =
        checkProxyActive() || isImpersonationActive || showBanner;

    return (
        <>
            {productValidationLoading ? (
                <SpinningLoaderContainer
                    isMobileView={window.innerWidth <= sizes.mobileDevice}
                >
                    <Spinner id="common-quickOrder-quickOrder-loadingSpinner" height={'5%'} small={true}>
                        <LoadingTextStyles color={'true'}>
                            {t('scheduleSurgery.quickOrder.bulkAddText')}{' '}
                            {
                                products?.filter((product) => {
                                    return product.quantity > 0;
                                }).length
                            }{' '}
                            {dynamicPluralization(
                                t('scheduleSurgery.quickOrder.productText'),
                                t('scheduleSurgery.quickOrder.productsText'),
                                products?.filter((product) => {
                                    return product.quantity > 0;
                                }).length
                            )}{' '}
                            {t('equity.quickOrder.loading.product.tocart')}{' '}
                        </LoadingTextStyles>
                    </Spinner>
                </SpinningLoaderContainer>
            ) : (
                <QuickOrderContainer
                    padding={
                        padding !== undefined
                            ? isEquity ? '0px 0px 10px 0px' : isConsignmentAdd ? isCondensedView ? '0px 0px 10px 0px' : '10px 0px 10px 0px' : padding
                            : isCondensedView
                                ? isBanner 
                                    ? '0px 0px 240px 0px' 
                                    : '10px 0px 240px 0px'
                                : isBanner 
                                    ? showSingleBanner ? '30px 0px 240px 0px' : '10px 0px 240px 0px'
                                    : '30px 0px 240px 0px'
                    }
                    overFlowY={!showBulkAdd ? false : 'hidden'}
                    isSurgeryTemplate = {isSurgeryTemplate}
                >
                    <QuickOrderHeader
                        cartProducts={cartProducts}
                        isCondensedView={isCondensedView}
                        quickOrderSearch={quickOrderSearch}
                        setQuickOrderSearch={setQuickOrderSearch}
                        t={t}
                        translation={t}
                        setShowBulkAdd={setShowBulkAdd}
                        selectedProduct={selectedProduct}
                        productsList={productsList}
                        handleOnOpen={handleOnOpen}
                        open={open}
                        loading={loading}
                        AutocompleteStyles={AutocompleteStyles}
                        productsListTemplate={productsListTemplate}
                        updateSelectedProduct={updateSelectedProduct}
                        autoCompleteInputChange={autoCompleteInputChange}
                        AutoCompleteInputFieldStyle={
                            AutoCompleteInputFieldStyle
                        }
                        SearchGrayInactive={SearchGrayInactive}
                        handlekeyPress={handlekeyPress}
                        cancelSearchRequest={cancelSearchRequest}
                        setOpen={setOpen}
                        isEquity={isEquity}
                        isSurgery={isSurgery}
                        isTemplate = {isTemplate}
                        // Equity-specific props
                        products={products}
                        getPriceForItems={getPriceForItems}
                        setIsCheckPrice={setIsCheckPrice}
                        setIsCheckPriceClicked={setIsCheckPriceClicked}
                        isSurgeryTemplate = {isSurgeryTemplate}
                        isConsignmentAdd={isConsignmentAdd}
                    />
                    {isBulkUpload && loading ? (
                        <Backdrop
                            showCloseButton={false}
                            showBackdrop={true}
                            isModal
                            loaderBackground
                        >
                            <SpinningLoaderContainer>
                                <Spinner id="common-quickOrder-quickOrder-bulkAddSpinner" height={'5%'} small>
                                    <LoadingTextStyles>
                                        {t(
                                            'equity.quickOrder.loading.product.adding'
                                        )}{' '}
                                        {setOrItemNumbers.length}{' '}
                                        {dynamicPluralization(
                                            'product',
                                            'products',
                                            setOrItemNumbers.length
                                        )}{' '}
                                    </LoadingTextStyles>
                                </Spinner>
                            </SpinningLoaderContainer>
                        </Backdrop>
                    ) : (
                        <>
                            {window.innerWidth <= sizes.mobileDevice && products.length > 0 ? (
                                (!isEquity && !isEquityTemplate) ? (
                                    ensureProductKeys(products).map((item, index) => (
                                        <CondensedMobileView
                                            showCheckBox={false}
                                            isShowCheckBox={false}
                                            marginOnMobileDevice={'0'}
                                            setOrItemDetails={item}
                                            removeCounter={removeCounter}
                                            setsQuantityCheck={setsQuantityCheck}
                                            removeCount={(item) => {
                                                removeCounter(
                                                    item.cfn,
                                                    item.isSet,
                                                    item
                                                );
                                            }}
                                            addCount={(item) => {
                                                addCounter(item.cfn, item.salesOrg);
                                            }}
                                            deleteProduct={(item) => {
                                                deleteSetOrItem(item.cfn, item.isSet, item);
                                            }}
                                            description={item.description}
                                            cartPage={true}
                                            isCart={true}
                                            isCounterButton={true}
                                            isSurgery={isSurgery}
                                            isEquity={isEquity}
                                            key={item.productKey || `${item.cfn || 'product'}-${index}`}
                                            background={
                                                index % 2 !== 0 ? '#f5f5f5cc' : ''
                                            }
                                            setNameFontSizeMobile={BASE_TEXT_PX}
                                            setNameFontSizeDesktop={BASE_TEXT_PX}
                                            onToggle={toggleProduct}
                                            isQuickOrder={true}
                                        />
                                    ))
                                ) : (
                                    <CondensedMobileViewList
                                        showCheckBox={false}
                                        expandedProductsItemList={expandedProducts}
                                        expandedProducts={expandedProducts}
                                        setExpandedProducts={setExpandedProducts}
                                        toggleProduct={toggleProduct}
                                        reviewScreen = {true}
                                        product={ensureProductKeys(products)}
                                        isQuickOrder = {true}
                                        handleSetItemClick={handleSetItemClick}
                                        removeCounter={(
                                            a,
                                            b,
                                            item,
                                            isBundle,
                                            ParentKey
                                        ) => {
                                            {
                                                isBundle == 'Bundle'
                                                    ? removeCounter(
                                                          ParentKey,
                                                          item.isSet,
                                                          item.productKey,
                                                          item.quantity
                                                      )
                                                    : removeCounter(
                                                    item.cfn,
                                                    item.isSet,
                                                    item
                                                );
                                            }
                                        }}
                                        setsQuantityCheck={setIsQuantityMoreThan50}
                                        addCounter={(
                                            item,
                                            productKey,
                                            isBundle,
                                            ParentKey
                                        ) => {
                                            {
                                                isBundle == 'bundle'
                                                    ? addCounter(
                                                          item.cfn,
                                                          ParentKey,
                                                          item.isSet,
                                                          item.productKey,
                                                          item.quantity
                                                      )
                                                    :  addCounter(item.cfn, null, null, item.productKey);
                                            }
                                        }}
                                        cartPage={true}
                                        equity={true}
                                        isEquity={true}
                                        deleteProduct={(
                                            item,
                                            isBundle
                                        ) => {
                                            deleteSetOrItem(item.cfn, isBundle, item);
                                        }}
                                        handleBundlePopup={handleBundlePopup}
                                        handleBundleSetItemClick={
                                            handleBundleSetItemClick
                                        }
                                        isQuickOrderEquityTemplate={isQuickOrderEquityTemplate}
                                        updateProductQuantity={updateProductQuantity}
                                    />
                                )
                            ) : (
                                    (!isEquity && !isEquityTemplate) ? (
                                    <ListView
                                    products={products}
                                    handleSetItemClick={handleSetItemClick}
                                    handleBundleSetItemClick={handleBundleSetItemClick}
                                    isQuickOrder={true}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={(item) => {
                                        removeCounter(
                                            item.cfn,
                                            item.isSet,
                                            item
                                        );
                                    }}
                                    addCount={(item) => {
                                        addCounter(item.cfn, null, null, item.productKey);
                                    }}
                                    deleteProduct={(item,isBundle) => {
                                        deleteSetOrItem(item.cfn, isBundle, item);
                                    }}
                                    isCartScreen={isCartScreen}
                                    isSurgery={isSurgery}
                                    isEquity={isEquity}
                                    moreTemplates={moreTemplates}
                                    handleBundlePopup={handleBundlePopup}
                                    isQuickOrderEquityTemplate={isQuickOrderEquityTemplate}
                                />
                            ) : (
                                   <ListView
                                    products={products}
                                    handleSetItemClick={handleSetItemClick}
                                    handleBundleSetItemClick={handleBundleSetItemClick}
                                    isQuickOrder={true}
                                    setsQuantityCheck={setsQuantityCheck}
                                    removeCount={(item) => {
                                        removeCounter(
                                            item.cfn,
                                            item.isSet,
                                            item
                                        );
                                    }}
                                    addCount={(item) => {
                                        addCounter(item.cfn, null, null, item.productKey);
                                    }}
                                    deleteProduct={(item,isBundle) => {
                                        deleteSetOrItem(item.cfn, isBundle, item);
                                    }}
                                    isCartScreen={isCartScreen}
                                    isSurgery={isSurgery}
                                    isEquity={isEquity}
                                    isEquityTemplate={isEquityTemplate}
                                    isEquityPage = {isEquityPage}
                                    handleBundlePopup={handleBundlePopup}
                                    isQuickOrderEquityTemplate={isQuickOrderEquityTemplate}
                                    updateProductQuantity={updateProductQuantity}
                                />
                            )
                            )}
                        </>
                    )}
                    <QuickOrderBulkAddPopup
                        show={showBulkAdd}
                        textValue={bulkValues}
                        setTextValue={setBulkValues}
                        landscapeMarginTop={landscapeMarginTop}
                        placeholder={t(
                            'scheduleSurgery.quickOrder.pastePlaceHolderText'
                        )}
                        title={t('scheduleSurgery.quickOrder.addOrPastInBulk')}
                        onAdd={addToList}
                        onPaste={copyToClipBoard}
                        linesLabel={t('scheduleSurgery.details.lines')}
                        editableHeight={editableHeight}
                        showBulkAdd={showBulkAdd}
                        setShowBulkAdd={setShowBulkAdd}
                        setBulkValues={setBulkValues}
                        bulkValues={bulkValues}
                        t={t}
                        resetPosition={resetPosition}
                        mbPaddingTop={mbPaddingTop}
                        mbTextAreaHeight={mbTextAreaHeight}
                        mobileHeight={mobileHeight}
                        smlMarginBottom={smlMarginBottom}
                    />

                    {/* {isTemplate && (
                        <BottomNavigation
                            justifyContent="space-around"
                            moblieJustifyContent="space-evenly"
                            padding={customStyle.padding}
                            right={'0'}
                            position={customStyle.position}
                            zIndex={'0'}
                            width={customStyle.width}
                        >
                            <BottomNavigationButtonContainer>
                                <Button
                                    id={'common-addToTemplateButton'}
                                    show
                                    // disabled={!products.length > 0}
                                    // primary={products.length > 0}
                                    variant={products.length > 0 ? ButtonStyles.primary : ButtonStyles.disabled}
                                    width={'289px'}
                                    height={'38px'}
                                    clicked={() => {
                                        dispatch(
                                            validateProducts({
                                                products:
                                                    validateProductsQuickOrder(
                                                        products
                                                    ),
                                                orderType: 'ZLC',
                                            })
                                        );
                                        setProductToBeAdded(products);
                                        setAdded(false);
                                    }}
                                    fontSize={'15px'}
                                >
                                    {t(
                                        'templates.common.addItemBundlePop.bundleItems.AddtoTemplate'
                                    )}
                                    &nbsp;
                                    {products.length > 0 && (
                                        <div>{`(${getQuantityCount(
                                            products
                                        )})`}</div>
                                    )}
                                </Button>
                            </BottomNavigationButtonContainer>
                        </BottomNavigation>
                    )} */}
                </QuickOrderContainer>
            )}

            {bomNotification && (
                <ModalDialog
                    modalHeight={'84vh'}
                    maxWidth={'1132px'}
                    backdropFilter={'blur(2px)'}
                    zIndex={'10000'}
                    marginTop={'10px'}
                    padding="10px"
                    height={isMobileView() ? '96.5%' : '101.5%'}
                    isFromBomChangeNotification={true}
                    containerWidth={'92%'}
                    containerRight={'4%'}
                    handleClose={() => closeBomModal()}
                >
                    <BomNotification
                        closeBomModal={closeBomModal}
                        setDetails={bomSetDetails}
                        isFromCart={true}
                    />
                </ModalDialog>
            )}

            <SetItemModal  //?
                handleClose={(isSet) => {
                    isSet ? showSetDetails(false) : showItemDetails(false);
                    setPopupFlag(false);
                    setProductStack([]);
                }}
                handleSetItemClick={handleSetItemClick}
                selectedItem={selectedItem}
                setDetails={setDetails}
                itemDetails={itemDetails}
                showSetDetails={showSetDetails}
                showItemDetails={showItemDetails}
                setPreviousItem={setPreviousItem}
                showBackText={true}
                isFromQuickOrder={true}
                backText={t('scheduleSurgery.cart.backToCart')}
                previousCfn={productStack[productStack.length - 2]}
                onBackClick={(item) => handleSetItemClick(item, true)}
                isOnlyPlusButton={true}
                zIndex={dialogZindex}
                onOpen={() => {
                    setDialogZindex(999);
                    onSelectOpen();
                }}
                onClose={() => {
                    setDialogZindex(10000);
                    onSelectClose();
                }}
                hideThresholdPopup={true}
            />
        </>
    );
};

export default QuickOrderContainerCommon;
